import React from "react"

import {ColorPickerStruct} from "./ColorPickerStruct"
import {ColorModel, ColorPickerBaseProps, RgbColor} from "../types"
import {equalColorObjects} from "../utils/compare"
import {hsvaToRgba, rgbaToHsva, rgbaToRgb} from "../utils/convert"

const colorModel: ColorModel<RgbColor> = {
    defaultColor: {r: 0, g: 0, b: 0},
    toHsva: ({r, g, b}) => rgbaToHsva({r, g, b, a: 1}),
    fromHsva: (hsva) => rgbaToRgb(hsvaToRgba(hsva)),
    equal: equalColorObjects
}

export const RgbColorPicker = (props: Partial<ColorPickerBaseProps<RgbColor>>): JSX.Element => (
    <ColorPickerStruct {...props} colorModel={colorModel} />
)
